import Vue from 'vue'
import Vuex from 'vuex'

import CityStore, { STORE_ACTIONS as CITY_STORE_ACTIONS, STORE_GETTERS as CITY_STORE_GETTERS } from '@/modules/global/localization/city/City.store'
import CountryStore, { STORE_ACTIONS as COUNTRY_STORE_ACTIONS, STORE_GETTERS as COUNTRY_STORE_GETTERS } from '@/modules/global/localization/country/Country.store'
import InscriptionLieuExamenStore, { STORE_ACTIONS as INSCRIPTION_LIEU_EXAMEN_STORE_ACTIONS, STORE_GETTERS as INSCRIPTION_LIEU_EXAMEN_STORE_GETTERS } from '@/modules/inscription-lieu-examen/InscriptionLieuExamen.store'
import UserSessionStore, { STORE_ACTIONS as USER_SESSION_STORE_ACTIONS, STORE_GETTERS as USER_SESSION_STORE_GETTERS } from '@/modules/global/user-session/UserSession.store'

Vue.use(Vuex)

export const STORE_ACTIONS = {
  ...CITY_STORE_ACTIONS,
  ...COUNTRY_STORE_ACTIONS,
  ...INSCRIPTION_LIEU_EXAMEN_STORE_ACTIONS,
  ...USER_SESSION_STORE_ACTIONS
}
type STORE_ACTIONS = INSCRIPTION_LIEU_EXAMEN_STORE_ACTIONS |
  COUNTRY_STORE_ACTIONS |
  CITY_STORE_ACTIONS |
  USER_SESSION_STORE_ACTIONS

export const STORE_GETTERS = {
  ...CITY_STORE_GETTERS,
  ...COUNTRY_STORE_GETTERS,
  ...INSCRIPTION_LIEU_EXAMEN_STORE_GETTERS,
  ...USER_SESSION_STORE_GETTERS
}
type STORE_GETTERS = INSCRIPTION_LIEU_EXAMEN_STORE_GETTERS |
  COUNTRY_STORE_GETTERS |
  CITY_STORE_GETTERS |
  USER_SESSION_STORE_GETTERS

export default new Vuex.Store({
  modules: {
    city: CityStore,
    country: CountryStore,
    inscriptionLieuExamen: InscriptionLieuExamenStore,
    userSession: UserSessionStore
  }
})
